__turbopack_context__.v({
  "hotDealCardBody": "HotDealCard-module__4NLYqW__hotDealCardBody",
});
